// Safari needs YouTube iframe src before lazysizes initializes to avoid Error 153.
(function () {
  var userAgent = navigator.userAgent;
  var vendor = navigator.vendor || '';
  var isSafari = /Safari/i.test(userAgent) && /Apple Computer/i.test(vendor) && !/(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|Android)/i.test(userAgent);

  if (!isSafari) {
    return;
  }

  document.querySelectorAll('iframe.js-youtube[data-src]').forEach(function (iframe) {
    iframe.setAttribute('src', iframe.getAttribute('data-src'));
    iframe.removeAttribute('data-src');
    iframe.classList.remove('lazyload');
  });
}());

//open drawer when we click "back" in checkout
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (typeof urlParams.get('open-cart-drawer') != "undefined" && urlParams.get('open-cart-drawer') != null && urlParams.get('open-cart-drawer') == 'true') {
    let button = document.getElementById('cart-drawer-toggle');
    button?.click();

    history.pushState(null, "", location.href.split("?")[0]);

    document.querySelectorAll('a').forEach(function (el) {
      let href = el.getAttribute('href');
      if (href && href.includes('?open-cart-drawer=true')) {
        el.setAttribute('href', href.replace('?open-cart-drawer=true', ''));
      }
    });
  }
});

// Back to top button functionality
document.addEventListener("DOMContentLoaded", () => {
  let button = document.querySelector('[href="#subscribe"]');

  button?.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#main-content').scrollIntoView({ behavior: 'smooth' });
  });

});

// Lazy load iframes on mobile devices
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) { // Mobile-only
    const lazyIframes = document.querySelectorAll('iframe[data-src]');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          iframe.src = iframe.dataset.src;
          iframe.removeAttribute('data-src');
          obs.unobserve(iframe);
        }
      });
    }, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.1
    });

    lazyIframes.forEach(iframe => observer.observe(iframe));
  }
});

// Subscription Cart Drawer Logic
document.addEventListener('change', async (e) => {
  if (!e.target.classList.contains('subscription-checkbox')) return;

  const wrapper = e.target.closest('.subscription-toggle');
  if (!wrapper) return;
  const plansContainer = wrapper.querySelector('.subscription-plans');
  if (!plansContainer) return;

  if (e.target.checked) {
    plansContainer.classList.remove('hidden');
  } else {
    plansContainer.classList.add('hidden');
  }

  e.target.setAttribute('aria-expanded', e.target.checked ? 'true' : 'false');
});

let isUpdatingSubscription = false;

document.addEventListener('change', async (e) => {
  if (!e.target.classList.contains('subscription-plan-select')) return;
  if (isUpdatingSubscription) return; // debounce

  isUpdatingSubscription = true;

  const wrapper = e.target.closest('.subscription-toggle');
  if (!wrapper) {
    isUpdatingSubscription = false;
    return;
  }
  const lineKey = wrapper.dataset.lineKey;
  const sellingPlanId = e.target.value;
  const selectNode = e.target;

  if (!lineKey || !sellingPlanId) {
    isUpdatingSubscription = false;
    return;
  }

  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const item = cart.items.find(i => i.key === lineKey);

    if (!item) {
      isUpdatingSubscription = false;
      return;
    }

    // Add loader directly next to the select field
    selectNode.disabled = true;
    let loader = selectNode.parentNode.querySelector('.subscription-loader');
    if (!loader) {
      loader = document.createElement('span');
      loader.className = 'subscription-loader';
      selectNode.parentNode.appendChild(loader);
    }
    
    // Also visually update drawer item
    const drawerItem = document.querySelector(`.product-cart-item [data-line-key="${lineKey}"]`)?.closest('.product-cart-item');
    if (drawerItem) drawerItem.classList.add('loading', 'thb-loading');

    // Make both requests sequentially (more stable)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.variant_id,
        quantity: item.quantity,
        selling_plan: sellingPlanId,
        properties: item.properties
      })
    });

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (err) {
    console.error('Subscription switch failed', err);
  } finally {
    isUpdatingSubscription = false;
    selectNode.disabled = false;
    const loader = selectNode.parentNode.querySelector('.subscription-loader');
    if (loader) loader.remove();
    const drawerItem = document.querySelector(`.product-cart-item [data-line-key="${lineKey}"]`)?.closest('.product-cart-item');
    if (drawerItem) drawerItem.classList.remove('loading', 'thb-loading');
  }
});

function getVisibleSubscriptionPromoDiscount() {
  const promoNodes = Array.from(document.querySelectorAll('.js-updated-discount-percentage'));

  for (const node of promoNodes) {
    const match = node.textContent.match(/\d+/);
    if (match) return Number(match[0]);
  }

  return 0;
}

function normalizeSubscriptionPlanLabel(label) {
  return label
    .replace(/delivery\s+every/ig, '')
    .replace(/with\s+\d+%\s+discount/ig, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizeSubscriptionPlanOptions(root = document) {
  root.querySelectorAll('.subscription-plan-select option').forEach(option => {
    if (!option.value || option.dataset.normalized === 'true') return;

    const normalizedLabel = normalizeSubscriptionPlanLabel(option.textContent);
    if (normalizedLabel) {
      option.textContent = normalizedLabel;
      option.dataset.normalized = 'true';
    }
  });
}

async function getMaxDiscount(handle) {
  try {
    const product = await fetch(`/products/${handle}.js`).then(r => r.json());
    let max = 0;

    if (product && product.selling_plan_groups) {
      product.selling_plan_groups.forEach(group => {
        group.selling_plans.forEach(plan => {
          plan.price_adjustments.forEach(adj => {
            if (adj.value_type === 'percentage') {
              max = Math.max(max, adj.value);
            }
          });
        });
      });
    }

    return max;
  } catch (e) {
    console.error('Error fetching max discount', e);
    return 0;
  }
}

function populateDiscounts() {
  document.querySelectorAll('.subscription-discount:not(.populated)').forEach(async el => {
    el.classList.add('populated'); // run only once
    const handle = el.dataset.handle;
    if (handle) {
      const standardDiscount = await getMaxDiscount(handle);
      const promoDiscount = getVisibleSubscriptionPromoDiscount();
      const discount = promoDiscount || standardDiscount;
      const copy = el.closest('.subscription-copy');

      if (discount) {
        el.textContent = discount;
      }

      if (copy && promoDiscount && standardDiscount && promoDiscount !== standardDiscount) {
        copy.innerHTML = `Subscribe &amp; Save <span class="subscription-saving"><span class="subscription-discount populated" data-variant-id="${el.dataset.variantId || ''}" data-handle="${handle}">${promoDiscount}</span>%</span> today, then ${standardDiscount}% forever`;
      } else if (copy && standardDiscount) {
        copy.innerHTML = `Subscribe &amp; Save <span class="subscription-saving"><span class="subscription-discount populated" data-variant-id="${el.dataset.variantId || ''}" data-handle="${handle}">${standardDiscount}</span>%</span> forever`;
      }
    }
  });

  normalizeSubscriptionPlanOptions();
}

// Observe DOM for newly added elements (cart:refresh uses DOM swap)
const cartObserver = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.addedNodes.length > 0) {
      populateDiscounts();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById('Cart-Drawer') || document.body;
  if (container) {
    cartObserver.observe(container, { childList: true, subtree: true });
  }
  populateDiscounts();
});

function enhanceJudgeMeMediaAccessibility(root = document) {
  const buttons = [];

  if (root.nodeType === Node.ELEMENT_NODE && root.matches('.jm-media-grid__item[aria-selected]')) {
    buttons.push(root);
  }

  if (root.querySelectorAll) {
    buttons.push(...root.querySelectorAll('.jm-media-grid__item[aria-selected]'));
  }

  buttons.forEach(button => {
    button.setAttribute('role', 'tab');

    const grid = button.closest('.jm-media-grid__container');
    if (grid) {
      grid.setAttribute('role', 'tablist');
      grid.setAttribute('aria-label', 'Review media');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  enhanceJudgeMeMediaAccessibility();

  const judgeMeAccessibilityObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          enhanceJudgeMeMediaAccessibility(node);
        }
      });
    });
  });

  judgeMeAccessibilityObserver.observe(document.body, { childList: true, subtree: true });
});
